import { FC, useEffect, useState } from 'react';

import { API, Tag } from '@brg/api';
import { useTheme } from "styled-components";
import { FInter, FlexBox, MagicBox, useIsMobile, useToasts } from "@brg/ui";
import { useDispatch } from "react-redux";
import { TagsActions } from "../../reducers/Tags";
import { createNewTag } from "../../actions/tags";
import { useTranslation } from "react-i18next";
import { BTag } from "../../../core/components";

export interface AddTagProps {
  parentTag: Tag;
  name: string;
  newTagEntityTypes?: string[];
}

export const AddTagField: FC<AddTagProps> = ({
  parentTag,
  name,
  newTagEntityTypes
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { info, error } = useToasts();
  const isMobile = useIsMobile();
  const dispatch = useDispatch()
  const [ hidden, setHidden ] = useState(false);

  const withoutMainCategory = (n: string): boolean => n !== 'main_category';

  const onAddTag = () => {
    const newTagProps = {
      name: [
        { lang: 'En', name },
        { lang: 'Ru', name },
      ],
      groupId: parentTag.tagId,
      entityTypes: newTagEntityTypes?.length ? newTagEntityTypes : parentTag.entityTypes.filter(withoutMainCategory),
      level: 0,
    }
    createNewTag(newTagProps).then(res => {
      if (res) {
        info(t('add_new_tag_success'))
        setHidden(true);
        const translatedTag = API.toLang(res, i18n.language)
        dispatch(TagsActions.setNewTag(translatedTag))
      }
    }).catch((err: any) => {
      error(t('add_new_tag_error'))
    })
  };

  useEffect(() => {
    setHidden(false);
  }, [name])

  if (hidden) {
    return null;
  }

  return (
    <FlexBox offsetTop={isMobile ? 16 : 24} align="center" directionMobile="column" alignMobile="flex-start">
        <FInter.SmallText color={theme.text.label}>
          {t('create_tag')}
        </FInter.SmallText>
      <MagicBox offsetTopMobile={16} offsetLeft={isMobile ? 0 : 16}>
        <BTag onClick={onAddTag}>
          {name}
        </BTag>
      </MagicBox>
    </FlexBox>
  );
};
import { FC, useEffect, useState } from 'react';

import { API, Tag } from '@brg/api';
import { useTheme } from "styled-components";
import { FInter, FlexBox, MagicBox, useIsMobile, useToasts } from "@brg/ui";
import { useDispatch } from "react-redux";
import { TagsActions } from "../../reducers/Tags";
import { createNewTag } from "../../actions/tags";
import { useTranslation } from "react-i18next";
import { BTag } from "../../../core/components";

export interface AddTagProps {
  parentTag: Tag;
  name: string;
  newTagEntityTypes?: string[];
}

export const AddTagField: FC<AddTagProps> = ({
  parentTag,
  name,
  newTagEntityTypes
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { info, error } = useToasts();
  const isMobile = useIsMobile();
  const dispatch = useDispatch()
  const [ hidden, setHidden ] = useState(false);

  const withoutMainCategory = (n: string): boolean => n !== 'main_category';

  const onAddTag = () => {
    const newTagProps = {
      name: [
        { lang: 'En', name },
        { lang: 'Ru', name },
      ],
      groupId: parentTag.tagId,
      entityTypes: newTagEntityTypes?.length ? newTagEntityTypes : parentTag.entityTypes.filter(withoutMainCategory),
      level: 0,
    }
    createNewTag(newTagProps).then(res => {
      if (res) {
        info(t('add_new_tag_success'))
        setHidden(true);
        const translatedTag = API.toLang(res, i18n.language)
        dispatch(TagsActions.setNewTag(translatedTag))
      }
    }).catch((err: any) => {
      error(t('add_new_tag_error'))
    })
  };

  useEffect(() => {
    setHidden(false);
  }, [name])

  if (hidden) {
    return null;
  }

  return (
    <FlexBox offsetTop={isMobile ? 16 : 24} align="center" directionMobile="column" alignMobile="flex-start">
        <FInter.SmallText color={theme.text.label}>
          {t('create_tag')}
        </FInter.SmallText>
      <MagicBox offsetTopMobile={16} offsetLeft={isMobile ? 0 : 16}>
        <BTag onClick={onAddTag}>
          {name}
        </BTag>
      </MagicBox>
    </FlexBox>
  );
};
